export default __webpack_public_path__ + "img/bec8f033fa74035788f35e4b6b3b95c8.png";